
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ExternalInvoiceDownloadDialog from '@/components/Transport/Accounting/ExternalInvoiceDownloadDialog.vue'
import { Invoice } from '@/models/accounting/Invoice'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'

@Component({
	components: { ExternalInvoiceDownloadDialog }
})
export default class ExternalDownloadDialog extends Vue {
	@Prop({ required: true })
	show!: boolean

	@Prop({ required: true })
	invoiceId!: string

	invoice: Invoice | null = null
	isLoading: boolean = false

	async created() {
		await this.loadInvoice()
	}

	@Watch('invoiceId')
	async onInvoiceIdChange() {
		await this.loadInvoice()
	}

	async loadInvoice() {
		if (!this.invoiceId) return
		this.isLoading = true
		try {
			const response = await Invoice.with(['documents', 'transports', 'transports.documents']).find(this.invoiceId)
			this.invoice = response.getData() as Invoice
        } catch (err) {
            // eslint-disable-next-line
			console.error('Error loading invoice', err)
			await Notification.Error(i18n.t('errors.load_error').toString())
			this.$emit('close')
		} finally {
			this.isLoading = false
		}
	}
}
